/**
 * OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPage
 *
 * Page component for OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPage
 * Path: /docs/tutorials/intermediate/guards
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateGuardsENDocScreenView as __OrbDocTutorialsIntermediateGuardsENDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsENDocScreenView';
import { OrbDocTutorialsIntermediateGuardsENDocAnalyticsView as __OrbDocTutorialsIntermediateGuardsENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPage(_props: OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Guards","description":"Make a transition conditional on the entity, the payload or the viewer, and keep every rule in one place.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/guards"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/guards"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/guards"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateGuardsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateGuardsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateGuardsENOrbDocTutorialsIntermediateGuardsENPage;
